export default "__VITE_ASSET__dd73008a__"